const namespace = "break";

export const SEATING = `${namespace}.seating`;
export const HOURLY = `${namespace}.hourly`;
export const SUSPENDED = `${namespace}.suspended`;
export const ADD_ON_BREAK = `${namespace}.add-on-break`;
export const REBUY = `${namespace}.rebuy`;
export const DEAL = `${namespace}.deal`;
export const HAND_FOR_HAND = `${namespace}.handForHand`;
